import { Instance, SnapshotIn, types } from 'mobx-state-tree';
import { Currency, CurrencyProps } from 'models/reusable-parts/currency';

export interface InvoiceProps {
  id: number;
  date: number;
  amount: CurrencyProps;
  url: string;
  isPaid: boolean;
}

export const Invoice = types.model({
  id: types.number,
  date: types.number,
  amount: Currency,
  url: types.string,
  isPaid: types.boolean,
});

export type InvoiceSnapshot = SnapshotIn<typeof Invoice>;
export type InvoiceInstance = Instance<typeof Invoice>;
